import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Icon, TextOverflowEllipsis } from "components/common";
import timerangeToString from "views/logic/queries/TimeRangeToString";
import { DEFAULT_TIMERANGE } from "views/Constants";
import useUserDateTime from "hooks/useUserDateTime";
import useGlobalOverride from "views/hooks/useGlobalOverride";
import useSearchResult from "views/hooks/useSearchResult";
import SearchQueryExecutionInfoHelper from "views/components/widgets/SearchQueryExecutionInfoHelper";
import useView from "views/hooks/useView";
const Wrapper = styled.div`
  width: max-content;
  display: flex;
  gap: 5px;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
const StyledIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.gray[60]};
  `
);
const getEffectiveWidgetTimerange = (result, activeQuery, searchTypeId) => {
  var _a, _b;
  const searchTypeResult = (_b = (_a = result == null ? void 0 : result.results) == null ? void 0 : _a[activeQuery]) == null ? void 0 : _b.searchTypes[searchTypeId];
  return searchTypeResult && "effective_timerange" in searchTypeResult ? searchTypeResult.effective_timerange : void 0;
};
const TimerangeInfo = ({
  className = void 0,
  widget,
  activeQuery = void 0,
  widgetId = void 0,
  returnsAllRecords = void 0
}) => {
  var _a, _b;
  const { t } = useTranslation("widgets");
  const { formatTime } = useUserDateTime();
  const { result } = (_a = useSearchResult()) != null ? _a : {};
  const { widgetMapping } = useView();
  const globalOverride = useGlobalOverride();
  const toLocalTimeWithMS = (dateTime) => formatTime(dateTime, "complete");
  const toInternalTime = (dateTime) => formatTime(dateTime, "internal");
  const globalTimerangeString = (globalOverride == null ? void 0 : globalOverride.timerange) ? t("timerange_info.global_override", { timerange: timerangeToString(globalOverride.timerange, toLocalTimeWithMS) }) : void 0;
  const searchTypeId = widgetId ? (_b = widgetMapping == null ? void 0 : widgetMapping.get(widgetId)) == null ? void 0 : _b.first() : void 0;
  const configuredTimerange = timerangeToString(widget.timerange || DEFAULT_TIMERANGE, toLocalTimeWithMS);
  const effectiveTimerange = activeQuery && searchTypeId ? getEffectiveWidgetTimerange(result, activeQuery, searchTypeId) : void 0;
  const effectiveTimerangeString = effectiveTimerange ? timerangeToString(effectiveTimerange, toInternalTime) : t("timerange_info.effective_unavailable");
  const currentWidgetMapping = widgetMapping == null ? void 0 : widgetMapping.get(widgetId);
  const timerange = globalTimerangeString || configuredTimerange;
  if (returnsAllRecords) {
    return /* @__PURE__ */ React.createElement(Wrapper, { className }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "warning", title: t("timerange_info.independent") }), /* @__PURE__ */ React.createElement(TextOverflowEllipsis, { titleOverride: effectiveTimerangeString }, t("timerange_info.all_time")));
  }
  return /* @__PURE__ */ React.createElement(SearchQueryExecutionInfoHelper, { currentWidgetMapping }, /* @__PURE__ */ React.createElement(Wrapper, { className }, /* @__PURE__ */ React.createElement(TextOverflowEllipsis, { titleOverride: effectiveTimerangeString }, timerange)));
};
export default TimerangeInfo;
